module.exports = "/static/assets/82be34b98c2cdc3b0a96e05484ccbc2b.png";